import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [infoCompany, setInfoCompany] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const getPageSection = () => {
    axios
      .get("/page-section/public/shows?sectionType=infoCompany")
      .then((res) => {
        setInfoCompany(res.data.data[0]);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getPageSection();
  }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = "Vui lòng nhập họ và tên";
    }

    if (!formData.email?.trim()) {
      newErrors.email = "Vui lòng nhập email";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email không hợp lệ";
    }

    if (!formData.phone?.trim()) {
      newErrors.phone = "Vui lòng nhập số điện thoại";
    } else if (!/^[0-9]{10,11}$/.test(formData.phone.replace(/\s/g, ""))) {
      newErrors.phone = "Số điện thoại không hợp lệ";
    }

    if (!formData.message?.trim() || formData.message?.length < 10) {
      newErrors.message = "Vui lòng nhập nội dung";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    axios
      .post("/contact/create", { ...formData, subject: "Liên hệ" })
      .then((res) => {
        toast.success(res.data.message);
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
        setErrors({});
      })
      .catch((err) => {
        setErrors(err.response?.data?.messages || err.response?.data);
        const errorMessage =
          err.response?.data?.messages ||
          err.response?.data ||
          "Đã xảy ra lỗi khi gửi liên hệ";
        toast.error(errorMessage);
        console.log(err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };
  const getContentByKey = (key) => {
    if (!infoCompany || !infoCompany.content) return "";
    const item = infoCompany.content.find((item) => item.key === key);
    return item ? item.value : "";
  };

  // Helper function to get URL by key
  // const getUrlByKey = (key) => {
  //   if (!infoCompany || !infoCompany.content) return "#";
  //   const item = infoCompany.content.find((item) => item.key === key);
  //   return item && item.url ? item.url : "#";
  // };

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <Link className="breadcrumb-item text-dark" to="/">
                Trang chủ
              </Link>
              <span className="breadcrumb-item active">Liên hệ</span>
            </nav>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <h2 className="section-title position-relative text-uppercase mx-xl-5 mb-4">
          <span className="bg-secondary pr-3">Liên hệ với chúng tôi</span>
        </h2>
        <div className="row px-xl-5">
          {/* Contact Form */}
          <div className="col-lg-7 mb-5">
            <div className="contact-form bg-light p-30">
              <form name="sentMessage" id="contactForm" onSubmit={handleSubmit}>
                <div className="control-group">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    id="name"
                    name="name"
                    placeholder="Họ và tên"
                    onChange={handleChange}
                    value={formData.name || ""}
                  />
                  {errors.name && (
                    <p className="text-danger small mt-1">{errors.name}</p>
                  )}
                </div>
                <div className="control-group mt-3">
                  <input
                    type="email"
                    className={`form-control ${
                      errors.email ? "is-invalid" : ""
                    }`}
                    id="email"
                    name="email"
                    placeholder="Email"
                    onChange={handleChange}
                    value={formData.email || ""}
                  />
                  {errors.email && (
                    <p className="text-danger small mt-1">{errors.email}</p>
                  )}
                </div>
                <div className="control-group mt-3">
                  <input
                    type="text"
                    className={`form-control ${
                      errors.phone ? "is-invalid" : ""
                    }`}
                    id="phone"
                    name="phone"
                    placeholder="Số điện thoại"
                    onChange={handleChange}
                    value={formData.phone || ""}
                  />
                  {errors.phone && (
                    <p className="text-danger small mt-1">{errors.phone}</p>
                  )}
                </div>
                <div className="control-group mt-3">
                  <textarea
                    className={`form-control ${
                      errors.message ? "is-invalid" : ""
                    }`}
                    rows="8"
                    id="message"
                    name="message"
                    placeholder="Nội dung"
                    onChange={handleChange}
                    value={formData.message || ""}
                  ></textarea>
                  {errors.message && (
                    <p className="text-danger small mt-1">{errors.message}</p>
                  )}
                </div>
                <div className="mt-4">
                  <button
                    className="btn btn-primary py-2 px-4"
                    type="submit"
                    id="sendMessageButton"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Đang gửi..." : "Gửi liên hệ"}
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-lg-5 mb-5">
            <div className="bg-light p-30 mb-30">
              <iframe
                style={{ width: "100%", height: "250px", border: "0" }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8880.86860121198!2d105.71502442173382!3d10.073251625187057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a0863a16c6bc15%3A0x569efc8044b9a742!2zNTM4IFbDtSBWxINuIEtp4buHdCwgTG9uZyBIb8OgLCBCw6xuaCBUaOG7p3ksIEPhuqduIFRoxqEsIFZp4buHdCBOYW0!5e1!3m2!1svi!2s!4v1745573144484!5m2!1svi!2s"
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
              ></iframe>
            </div>
            <div className="bg-light p-30 mb-3">
              <p className="mb-2">
                <i className="fa fa-map-marker-alt text-primary mr-3"></i>
                {getContentByKey("address")}
              </p>

              <p className="mb-2">
                <i className="fa fa-envelope text-primary mr-3"></i>
                {getContentByKey("email")}
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt text-primary mr-3"></i>
                {getContentByKey("number_phone")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
